// FIX_RULES 10.3 (NEW-83): one way to show money and dates. Display only - never use these for a stored figure.
//   money(1234.5)              -> "₹1,234.50"   (Indian grouping, 2 decimals; "-" for nothing)
//   amount(1234.5)             -> "1,234.50"    (the same without the sign, for cells under a ₹ heading)
//   date("2026-10-16")         -> "16-10-2026"  (also takes "2026-10-16 14:05:00" or a Date)
//   dateTime("2026-10-16 14:05:00") -> "16-10-2026 14:05"
// Server dates are "YYYY-MM-DD[ HH:MM:SS]" in Indian time; they are read as written, never shifted by the browser's zone.

const EMPTY = "-";

const toNumber = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const amount = (v) => {
  const n = toNumber(v);
  return n === null ? EMPTY : n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const money = (v) => {
  const n = toNumber(v);
  return n === null ? EMPTY : `${n < 0 ? "-" : ""}₹${amount(Math.abs(n))}`;
};

const parts = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (v instanceof Date) {
    if (Number.isNaN(v.getTime())) return null;
    const p = (x) => String(x).padStart(2, "0");
    return { y: v.getFullYear(), m: p(v.getMonth() + 1), d: p(v.getDate()), t: `${p(v.getHours())}:${p(v.getMinutes())}` };
  }
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (!m || m[1] === "0000") return null;
  return { y: m[1], m: m[2], d: m[3], t: m[4] ? `${m[4]}:${m[5]}` : null };
};

export const date = (v) => {
  const p = parts(v);
  return p ? `${p.d}-${p.m}-${p.y}` : v ? String(v) : EMPTY;
};

export const dateTime = (v) => {
  const p = parts(v);
  if (!p) return v ? String(v) : EMPTY;
  return p.t ? `${p.d}-${p.m}-${p.y} ${p.t}` : `${p.d}-${p.m}-${p.y}`;
};

// "2026-10" -> "Oct 2026"
export const month = (v) => {
  const m = String(v || "").match(/^(\d{4})-(\d{2})/);
  if (!m) return v ? String(v) : EMPTY;
  return new Date(Number(m[1]), Number(m[2]) - 1, 1).toLocaleDateString("en-IN", { month: "short", year: "numeric" });
};

const format = { money, amount, date, dateTime, month };
export default format;
